import React from "react";
import {connect} from "react-redux";
import Header from "../../../common/components/Header";
import {Button, Confirm, Grid, Modal, Card, Container, Form, Input, Message, Popup} from "semantic-ui-react";
import {
    deleteBillingOrg,
    fetchOneOrganization,
    openEditBillingOrgModal, toggleCPModal,
    toggleDeleteBillingOrgModal, toggleEditBillingOrgModal, updatedOrgRefresh, validateBillingOrg, validateCPUser
} from "../actions/BillingOrganizationsActions";
import AddEditBillingOrgForm from "./AddEditBillingOrgForm";
import BillingOrganizationsInfo from "./BillingOrganizationsInfo";
import * as Validation from "../../../common/utils/Validation";
import Breadcrumb from "../../../common/partials/Breadcrumb";
import { setBreadCrumb } from "../../../veritas/breadcrumb/BreadcrumbActions";
import LastUpdated from "../../../common/partials/LastUpdated";
import MARVEL from "../../../common/utils/MarvelUrls";
import BillingSidebarButtons from "../../shared/BillingSidebarButtons";
import Sidebar from "../../../common/components/Sidebar";

export class BillingOrganizationsDetailPage extends React.Component {

    state = {
        portalPayload: {
            firstName: "",
            lastName: "",
            email: "",
            username: "",
            password: null,
            org_name: "",
        }
    }

    componentDidMount() {
        const {orgID} = this.props.params;
        this.props.getOrganizationDetail(orgID);

        this.props.setBreadCrumb({
            parent: { url: '/billing', text: 'Billing   ' },
            list: { url: '/billing/organizations', text: 'Organizations' },
            service: { url: '', text: '' },
            source: { url: '', text: '' }
        })
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {orgID} = this.props.params;
        if (this.props.updatedOrg) {
            this.props.getOrganizationDetail(orgID);
            this.props.updatedOrgRefresh();
        }
        document.title = `Org - ` + this.props.organizationDetail.display_name;

        this.props.setBreadCrumb({
            parent: { url: '/billing', text: 'Billing   ' },
            list: { url: '/billing/organizations', text: 'Organizations' },
            service: { url: `/billing/organizations/${orgID}`, text: this.props.organizationDetail.name},
            source: { url: '', text: '' }
        })
    }

    handleEditOrg = () => {
        const { organizationDetail, organizationAddress, organizationBilling } = this.props;
        this.props.openEditOrgModal(organizationDetail, organizationAddress, organizationBilling);
    }

    handleDeleteOrg = () => {
        this.props.toggleDeleteOrgModal();
    }

    handleEnableCP = () => {
        this.props.toggleCPModal();
    }

    handleCloseEnableCPModal = () => {
        this.setState({
            portalPayload: {
                firstName: "",
                lastName: "",
                email: "",
                username: "",
                password: null,
                org_name: "",
            }});
        Validation.clearMessages();
        this.props.toggleCPModal();
    }

    handleCPSubmit = () => {
        const { portalPayload } = this.state;
        portalPayload.org_name = this.props.organizationDetail.name;
        this.props.validateCPUserForm(portalPayload)
    }

    // use the built-in component state to track the
    // inputs and form the payload object.
    handleInputChange = (e, { name, value }) => {
        if (name === "firstName") {
            this.setState(prevState => ({
                portalPayload: {
                    ...prevState.portalPayload,
                    firstName: value,
                }
            }));
        } else if (name === "lastName") {
            this.setState(prevState => ({
                portalPayload: {
                    ...prevState.portalPayload,
                    lastName: value,
                }
            }));
        } else if (name === "email") {
            this.setState(prevState => ({
                portalPayload: {
                    ...prevState.portalPayload,
                    email: value,
                    username: value,
                }
            }));
        }
    }

    get organizationName() {
        const {organizationDetail, canEdit} = this.props;
        const lastUpdatedOnDate = organizationDetail?.last_updated;

        return(
            <div className="header-container">
                <div className="title-alignment">
                    <span className="detail-name">
                        <h1>{organizationDetail?.display_name}</h1>
                </span>
                    {canEdit
                        ? (<span className="buttons-alignment">
                            <Popup
                                content={"Edit"}
                                trigger={
                                    <Button
                                        onClick={this.handleEditOrg}
                                        icon="edit outline"
                                    />
                                }
                            />
                            <Popup
                                content={"Delete"}
                                trigger={
                                    <Button
                                        onClick={this.handleDeleteOrg}
                                        color={"red"}
                                        icon="trash alternate outline"
                                    />
                                }
                            />
                        </span>)
                        : null
                    }
                </div>

                <div className="org-title-alignment">
                    <span style={{display: "inline-block"}} />
                    <span className="org-buttons-alignment">
                        <div className="flex">
                            <label style={{margin: 0}}> Last Updated On: </label>
                            <LastUpdated lastUpdated={lastUpdatedOnDate} />
                        </div>
                    </span>
                </div>
            </div>
        );
    }

    handleEditBillingOrgClick = () => {
        this.props.toggleEditBillingOrgModal();
    }

    handleEditBillingOrgFormSubmit = () => {
        this.props.validateOrgForm(this.props.billingOrgObject);
    }

    handleCancelDeleteClick = () => {
        this.props.toggleDeleteBillingOrgModal();
    }

    handleDeleteBillingOrgClick = () => {
        this.props.deleteBillingOrg(this.props.organizationDetail.id);
        this.props.navigate(MARVEL.BILLING.organizations);
    }

    handleCPEnableDismiss = () => {
        Validation.clearMessages();
    }

    get pageContent() {
        const { organizationDetail, organizationAddress, organizationBilling, organizationTenants } = this.props;
        return (
            <div style={{padding: "20px 20px 0 20px"}}>
                <Grid relaxed={true}>
                    <Grid.Column width={12}>
                        {this.organizationName}
                        {organizationDetail && organizationAddress && organizationBilling
                            ?
                            (<BillingOrganizationsInfo
                                organizationDetail={organizationDetail}
                                associatedAddresses={organizationAddress}
                                associatedBilling={organizationBilling}
                                associatedTenants={organizationTenants}
                            />)
                            : null
                        }

                    </Grid.Column>
                    <Grid.Column width={4}>
                    </Grid.Column>
                </Grid>
            </div>
        )
    };


    render() {

        const {
            editOrgModalOpen,
            deleteOrgWarning,
            organizationDetail,
            enableCPModal,
            formMessage, formMessageHeader, formWarningNotification, formErrorNotification,
        } = this.props;

        const { portalPayload } = this.state;

        return(
            <div className='billing'>
                <Header />
                <Grid relaxed={true}>
                    <Grid.Column width={3}>
                        <Sidebar>
                            <BillingSidebarButtons />
                        </Sidebar>
                    </Grid.Column>
                    <Grid.Column width={13}>
                        <Breadcrumb />
                        {this.pageContent}
                    </Grid.Column>

                    <Modal
                        centered={false}
                        open={editOrgModalOpen}
                    >
                        <Modal.Header>
                            {`Edit Organization Details for ${organizationDetail?.display_name}`}
                        </Modal.Header>
                        <Modal.Content scrolling>
                            <AddEditBillingOrgForm />
                        </Modal.Content>
                        <Modal.Actions>
                            <Button
                                type="button"
                                color="red"
                                inverted
                                onClick={this.handleEditBillingOrgClick}>
                                Close
                            </Button>
                            <Button
                                type="submit"
                                color="green"
                                inverted
                                onClick={this.handleEditBillingOrgFormSubmit}>
                                Submit
                            </Button>
                        </Modal.Actions>
                    </Modal>

                    <Confirm
                        open={deleteOrgWarning}
                        content="Are you sure you want to delete this Organization."
                        onCancel={this.handleCancelDeleteClick}
                        onConfirm={this.handleDeleteBillingOrgClick}
                    />

                    <Modal
                        centered={false}
                        open={enableCPModal}
                    >
                        <Modal.Header>
                            {`Enable Customer Portal for ${organizationDetail?.display_name}`}
                        </Modal.Header>
                        <Modal.Content scrolling>
                            <Container>
                                <Form>
                                    <Card fluid>
                                        <Card.Content>
                                            <Form.Group widths="equal">
                                                <Form.Field
                                                    onChange={this.handleInputChange}
                                                    required
                                                    control={Input}
                                                    type="text"
                                                    label="First Name"
                                                    placeholder="First Name"
                                                    value={portalPayload.firstName}
                                                    name="firstName"
                                                />
                                                <Form.Field
                                                    onChange={this.handleInputChange}
                                                    required
                                                    control={Input}
                                                    type="text"
                                                    label="Last Name"
                                                    placeholder="Last Name"
                                                    value={portalPayload.lastName}
                                                    name="lastName"
                                                />
                                                <Form.Field
                                                    onChange={this.handleInputChange}
                                                    required
                                                    control={Input}
                                                    type="text"
                                                    label="Email"
                                                    placeholder="Email Address"
                                                    value={portalPayload.email}
                                                    name="email"
                                                />
                                            </Form.Group>
                                        </Card.Content>
                                    </Card>
                                </Form>

                                {formWarningNotification || formErrorNotification
                                    ? (
                                        <div style={{paddingTop: "30px"}}>
                                            <Message
                                                error={formErrorNotification}
                                                warning={formWarningNotification}
                                                header={formMessageHeader}
                                                list={formMessage}
                                                visible={formWarningNotification || formErrorNotification}
                                                onDismiss={this.handleCPEnableDismiss}
                                            />
                                        </div>
                                    )
                                    : null}

                            </Container>
                        </Modal.Content>
                        <Modal.Actions>
                            <Button type="button" color="red" inverted onClick={this.handleCloseEnableCPModal}>
                                Close
                            </Button>
                            <Button color="green" inverted type="submit" onClick={this.handleCPSubmit}>
                                Submit
                            </Button>
                        </Modal.Actions>
                    </Modal>

                </Grid>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    canEdit: state.marvel.user.access.accessLevel.isDPEditor,
    canApprove: state.marvel.user.access.accessLevel.isDPAdmin,
    updatedOrg: state.billing.organizations.updatedOrg,
    organizationDetail: state.billing.organizations.organizationDetail,
    organizationAddress: state.billing.organizations.organizationAddress,
    organizationBilling: state.billing.organizations.organizationBilling,
    organizationTenants: state.billing.organizations.organizationTenants,
    enableCPModal: state.billing.organizations.enableCPModal,

    billingOrgObject: state.billing.addEditBillingOrg.billingOrgObject,
    editOrgModalOpen: state.billing.addEditBillingOrg.editOrgModalOpen,
    deleteOrgWarning: state.billing.addEditBillingOrg.deleteOrgWarning,

    formMessage: state.marvel.message.formMessage,
    formWarningNotification: state.marvel.message.formWarningNotification,
    formErrorNotification: state.marvel.message.formErrorNotification,
    formMessageHeader: state.marvel.message.formMessageHeader,
});

const mapDispatchToProps = dispatch => ({
    getOrganizationDetail: (orgID) => {dispatch(fetchOneOrganization(orgID))},
    updatedOrgRefresh: () => {dispatch(updatedOrgRefresh())},
    openEditOrgModal: (organizationDetail, organizationAddress, organizationBilling) => {
        dispatch(openEditBillingOrgModal(organizationDetail, organizationAddress, organizationBilling))},
    toggleDeleteOrgModal: () => {dispatch(toggleDeleteBillingOrgModal())},

    toggleEditBillingOrgModal: () => {dispatch(toggleEditBillingOrgModal())},
    toggleDeleteBillingOrgModal: () => {dispatch(toggleDeleteBillingOrgModal())},
    toggleCPModal: () => {dispatch(toggleCPModal())},

    validateOrgForm: (billingOrgObject) => {dispatch(validateBillingOrg(billingOrgObject))},
    validateCPUserForm: (portalPayload) => {dispatch(validateCPUser(portalPayload))},
    deleteBillingOrg: (orgIdForDelete) => {dispatch(deleteBillingOrg(orgIdForDelete))},
    setBreadCrumb: (crumb) => { dispatch(setBreadCrumb(crumb)) },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(BillingOrganizationsDetailPage)
